import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Spinner, Button, ButtonGroup, Form } from "react-bootstrap";
import { FaStar, FaRegStar, FaSearch } from "react-icons/fa";

const KimpInfo = () => {
  const [coinList, setCoinList] = useState(["KRW-1INCH", "KRW-A", "KRW-AAVE", "KRW-ADA", "KRW-AERGO", "KRW-AGLD", "KRW-AHT", "KRW-AKT", "KRW-ALGO", "KRW-ALT", "KRW-ANIME", "KRW-ANKR", "KRW-APT", "KRW-AQT", "KRW-ARB", "KRW-ARDR", "KRW-ARK", "KRW-ARKM", "KRW-ASTR", "KRW-ATH", "KRW-ATOM", "KRW-AUCTION", "KRW-AVAX", "KRW-AWE", "KRW-AXL", "KRW-AXS", "KRW-BAT", "KRW-BCH", "KRW-BEAM", "KRW-BERA", "KRW-BIGTIME", "KRW-BLAST", "KRW-BLUR", "KRW-BONK", "KRW-BORA", "KRW-BOUNTY", "KRW-BSV", "KRW-BTC", "KRW-BTT", "KRW-CARV", "KRW-CBK", "KRW-CELO", "KRW-CHZ", "KRW-CKB", "KRW-COMP", "KRW-COW", "KRW-CRO", "KRW-CTC", "KRW-CVC", "KRW-CYBER", "KRW-DEEP", "KRW-DKA", "KRW-DOGE", "KRW-DOT", "KRW-DRIFT", "KRW-EGLD", "KRW-ELF", "KRW-ENA", "KRW-ENS", "KRW-ERA", "KRW-ETC", "KRW-ETH", "KRW-FCT2", "KRW-FIL", "KRW-FLOW", "KRW-G", "KRW-GAME2", "KRW-GAS", "KRW-GLM", "KRW-GMT", "KRW-GRS", "KRW-GRT", "KRW-HBAR", "KRW-HIVE", "KRW-HP", "KRW-HUNT", "KRW-HYPER", "KRW-ICX", "KRW-ID", "KRW-IMX", "KRW-INJ", "KRW-IOST", "KRW-IOTA", "KRW-IP", "KRW-IQ", "KRW-JST", "KRW-JTO", "KRW-JUP", "KRW-KAITO", "KRW-KAVA", "KRW-KNC", "KRW-LAYER", "KRW-LINK", "KRW-LPT", "KRW-LSK", "KRW-MANA", "KRW-MASK", "KRW-MBL", "KRW-ME", "KRW-MED", "KRW-META", "KRW-MEW", "KRW-MINA", "KRW-MLK", "KRW-MNT", "KRW-MOC", "KRW-MOCA", "KRW-MOODENG", "KRW-MOVE", "KRW-MTL", "KRW-MVL", "KRW-NEAR", "KRW-NEO", "KRW-NEWT", "KRW-NXPC", "KRW-OM", "KRW-OMNI", "KRW-ONDO", "KRW-ONG", "KRW-ONT", "KRW-OP", "KRW-ORBS", "KRW-ORCA", "KRW-PENDLE", "KRW-PENGU", "KRW-PEPE", "KRW-POKT", "KRW-POL", "KRW-POLYX", "KRW-POWR", "KRW-PROVE", "KRW-PUNDIX", "KRW-PYTH", "KRW-QKC", "KRW-QTUM", "KRW-RAY", "KRW-RENDER", "KRW-RVN", "KRW-SAFE", "KRW-SAHARA", "KRW-SAND", "KRW-SC", "KRW-SEI", "KRW-SHIB", "KRW-SIGN", "KRW-SNT", "KRW-SOL", "KRW-SONIC", "KRW-SOPH", "KRW-STEEM", "KRW-STG", "KRW-STORJ", "KRW-STRAX", "KRW-STRIKE", "KRW-STX", "KRW-SUI", "KRW-SXP", "KRW-SYRUP", "KRW-T", "KRW-TAIKO", "KRW-TFUEL", "KRW-THETA", "KRW-TIA", "KRW-TOKAMAK", "KRW-TRUMP", "KRW-TRX", "KRW-TT", "KRW-UNI", "KRW-USDC", "KRW-USDT", "KRW-UXLINK", "KRW-VANA", "KRW-VET", "KRW-VIRTUAL", "KRW-VTHO", "KRW-W", "KRW-WAL", "KRW-WAVES", "KRW-WAXP", "KRW-WCT", "KRW-XEC", "KRW-XLM", "KRW-XRP", "KRW-XTZ", "KRW-ZETA", "KRW-ZIL", "KRW-ZRO", "KRW-ZRX"]);
  const [prices, setPrices] = useState({});
  const [binancePrices, setBinancePrices] = useState({});
  const [exchangeRate, setExchangeRate] = useState(1300);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("volume");
  const [sortOrder, setSortOrder] = useState("desc");
  const [viewMode, setViewMode] = useState("all");
  const [favorites, setFavorites] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const storedFavorites = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(storedFavorites);

    const fetchMarketData = async () => {
      try {
        const response = await axios.get("https://api.upbit.com/v1/market/all");
        const krwMarkets = response.data.filter(market => market.market.startsWith("KRW-")).map(market => market.market);
        setCoinList(krwMarkets);
        setLoading(false);
      } catch (error) {
        console.error("코인 목록 가져오기 실패:", error);
        setLoading(false);
      }
    };

    const fetchExchangeRate = async () => {
      try {
        const response = await axios.get("https://api.exchangerate-api.com/v4/latest/USD");
        setExchangeRate(response.data.rates.KRW);
      } catch (error) {
        console.error("환율 정보 가져오기 실패:", error);
      }
    };

    fetchMarketData();
    fetchExchangeRate();
  }, []);
  /*
    useEffect(() => {
      if (coinList.length === 0) return;
  
      const wsUpbit = new WebSocket("wss://api.upbit.com/websocket/v1");
      const wsBinance = new WebSocket("wss://stream.binance.com:9443/ws");
  
      wsUpbit.onopen = () => {
        wsUpbit.send(JSON.stringify([{ ticket: "crypto-market" }, { type: "ticker", codes: coinList }]));
      };
  
      wsUpbit.onmessage = event => {
        event.data.text().then(data => {
          const json = JSON.parse(data);
          setPrices(prev => ({
            ...prev,
            [json.code]: {
              name: json.code.replace("KRW-", ""),
              price: json.trade_price,
            },
          }));
        });
      };
  
      const binanceSymbols = coinList.map(market => market.replace("KRW-", "").toLowerCase() + "usdt");
  
      wsBinance.onopen = () => {
        wsBinance.send(JSON.stringify({ method: "SUBSCRIBE", params: binanceSymbols.map(symbol => `${symbol}@ticker`), id: 1 }));
      };
  
      wsBinance.onmessage = event => {
        const data = JSON.parse(event.data);
        if (data.s && data.c) {
          setBinancePrices(prev => ({
            ...prev,
            [data.s.toUpperCase().replace("USDT", "")]: parseFloat(data.c),
          }));
        }
      };
  
      return () => {
        wsUpbit.close();
        wsBinance.close();
      };
    }, [coinList]);
  */
  useEffect(() => {
    if (!coinList || coinList.length === 0) return;

    let wsUpbit;
    let wsBinance;
    let reconnectUpbitTimer = null;
    let reconnectBinanceTimer = null;

    const connectUpbit = () => {
      wsUpbit = new WebSocket("wss://api.upbit.com/websocket/v1");

      wsUpbit.onopen = () => {
        const subscribeMsg = [
          { ticket: "crypto-market" },
          { type: "ticker", codes: coinList },
        ];
        wsUpbit.send(JSON.stringify(subscribeMsg));
      };

      wsUpbit.onmessage = event => {
        event.data.text().then(data => {
          try {
            const json = JSON.parse(data);
            if (json.code && json.trade_price) {
              setPrices(prev => ({
                ...prev,
                [json.code]: {
                  name: json.code.replace("KRW-", ""),
                  price: json.trade_price,
                },
              }));
            }
          } catch (e) {
            console.error("Upbit JSON Parse Error:", e);
          }
        });
      };

      wsUpbit.onclose = () => {
        console.warn("Upbit WebSocket closed. Reconnecting in 3s...");
        reconnectUpbitTimer = setTimeout(connectUpbit, 3000);
      };

      wsUpbit.onerror = (e) => {
        console.error("Upbit WebSocket error:", e);
        wsUpbit.close(); // 강제 종료 후 재연결 트리거
      };
    };

    const connectBinance = () => {
      wsBinance = new WebSocket("wss://stream.binance.com:9443/ws");

      const binanceSymbols = coinList.map(market => market.replace("KRW-", "").toLowerCase() + "usdt");

      wsBinance.onopen = () => {
        wsBinance.send(JSON.stringify({
          method: "SUBSCRIBE",
          params: binanceSymbols.map(symbol => `${symbol}@ticker`),
          id: 1
        }));
      };

      wsBinance.onmessage = event => {
        try {
          const data = JSON.parse(event.data);
          if (data.s && data.c) {
            setBinancePrices(prev => ({
              ...prev,
              [data.s.toUpperCase().replace("USDT", "")]: parseFloat(data.c),
            }));
          }
        } catch (e) {
          console.error("Binance JSON Parse Error:", e);
        }
      };

      wsBinance.onclose = () => {
        console.warn("Binance WebSocket closed. Reconnecting in 3s...");
        reconnectBinanceTimer = setTimeout(connectBinance, 3000);
      };

      wsBinance.onerror = (e) => {
        console.error("Binance WebSocket error:", e);
        wsBinance.close(); // 강제 종료 후 재연결 트리거
      };
    };

    // 최초 연결
    connectUpbit();
    connectBinance();

    return () => {
      if (wsUpbit) wsUpbit.close();
      if (wsBinance) wsBinance.close();
      if (reconnectUpbitTimer) clearTimeout(reconnectUpbitTimer);
      if (reconnectBinanceTimer) clearTimeout(reconnectBinanceTimer);
    };
  }, [coinList]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleFavorite = (coinName) => {
    const updatedFavorites = favorites.includes(coinName)
      ? favorites.filter(fav => fav !== coinName)
      : [...favorites, coinName];

    setFavorites(updatedFavorites);
    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
  };

  const handleSort = key => {
    if (sortBy === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(key);
      setSortOrder("asc");
    }
  };

  const getSortIcon = key => (sortBy === key ? (sortOrder === "asc" ? "▲" : "▼") : "");

  const handleViewModeChange = mode => {
    setViewMode(mode);
  };

  const sortedData = Object.values(prices).map(coin => {
    const binancePrice = binancePrices[coin.name] || 0;
    const premium = binancePrice > 0 ? ((coin.price - binancePrice * exchangeRate) / (binancePrice * exchangeRate)) * 100 : 0;
    return { ...coin, binancePrice, premium };
  }).sort((a, b) => {
    if (sortOrder === "asc") return a[sortBy] > b[sortBy] ? 1 : -1;
    if (sortOrder === "desc") return a[sortBy] < b[sortBy] ? 1 : -1;
    return 0;
  });

  const displayedData = sortedData
    .filter(coin => viewMode === "favorite" ? favorites.includes(coin.name) : true)
    .filter(coin => coin.name.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <div className="crypto-card-container py-4" style={{ maxWidth: 600 }}>
      <div className="crypto-card">
        <h5 className="fw-bold text-center mb-3">🇰🇷 업비트 vs 바이낸스 김프 비교</h5>

        {/* 검색 및 환율 */}
        <div className="crypto-search-wrapper">
          <FaSearch className="crypto-search-icon" />
          <Form.Control
            type="text"
            placeholder="코인명 검색 (예: BTC, ETH)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="crypto-search-input"
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <ButtonGroup style={{ borderRadius: '10px', overflow: 'hidden', width: '220px' }}>
            <Button
              variant={viewMode === "all" ? "primary" : "outline-primary"}
              onClick={() => handleViewModeChange("all")}
              style={{ fontSize: '0.82rem', fontWeight: 600 }}
            >
              전체 코인
            </Button>
            <Button
              variant={viewMode === "favorite" ? "primary" : "outline-primary"}
              onClick={() => handleViewModeChange("favorite")}
              style={{ fontSize: '0.82rem', fontWeight: 600 }}
            >
              ⭐ 관심 ({favorites.length})
            </Button>
          </ButtonGroup>
          
          <div className="text-secondary small" style={{ fontSize: '0.8rem' }}>
            기준환율: <strong className="text-dark font-monospace">{exchangeRate.toFixed(2)} KRW</strong>
          </div>
        </div>

        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="crypto-table-wrapper">
            <Table hover size="sm" className="crypto-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort("name")} style={{ cursor: "pointer", width: '25%' }}>{getSortIcon("name")} 코인</th>
                  <th onClick={() => handleSort("price")} style={{ cursor: "pointer", textAlign: 'right' }}>{getSortIcon("price")} 업비트</th>
                  <th onClick={() => handleSort("binancePrice")} style={{ cursor: "pointer", textAlign: 'right' }}>{getSortIcon("binancePrice")} 바이낸스</th>
                  <th onClick={() => handleSort("premium")} style={{ cursor: "pointer", textAlign: 'right', width: '22%' }}>{getSortIcon("premium")} 김프</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center text-muted py-4">조회된 코인이 없습니다.</td>
                  </tr>
                ) : (
                  displayedData.map(coin => {
                    const isFav = favorites.includes(coin.name);
                    return (
                      <tr key={coin.name}>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <button
                              className={`crypto-star-btn ${isFav ? 'active' : ''}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleFavorite(coin.name);
                              }}
                            >
                              {isFav ? <FaStar /> : <FaRegStar />}
                            </button>
                            <span className="fw-bold text-dark">{coin.name}</span>
                          </div>
                        </td>
                        <td className="text-end font-monospace">{coin.price.toLocaleString()}원</td>
                        <td className="text-end font-monospace text-secondary">${coin.binancePrice.toLocaleString()}</td>
                        <td className="text-end">
                          <span className={`crypto-premium-capsule ${coin.premium >= 0 ? 'positive' : 'negative'}`}>
                            {coin.premium >= 0 ? `+${coin.premium.toFixed(2)}%` : `${coin.premium.toFixed(2)}%`}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
};

export { KimpInfo };
